(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('InventoryStatusController', InventoryStatusController);

    InventoryStatusController.$inject = ['$scope', '$state', 'DataUtils', 'InventoryStatus','NgTableParams'];

    function InventoryStatusController ($scope, $state, DataUtils, InventoryStatus,NgTableParams) {
        var vm = this;
//        vm.inventoryStatus = [{code:'I01',description:'Đủ sử dụng', note:'Tổng SL tồn > = Định mức(ĐM) tồn tối thiểu',status:'1'},
//                     {code:'I02',description:'Đặt hàng', note:'½ ĐM tồn tối thiểu < = Tổng SL tồn < ĐM tồn tối thiểu',status:'1'},
//                     {code:'I03',description:'Khẩn Cấp', note:'Tổng SL tồn < = ½ ĐM tồn tối thiểu',status:'1'}];
////        vm.inventoryStatus = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
        	InventoryStatus.query(function(result) {
                vm.inventorystatus = result;
                if(vm.inventorystatus !=null && vm.inventorystatus.length > 0){
                	var i;
                	for( i = 0; i < vm.inventorystatus.length; i++){
                		if(vm.inventorystatus[i].status == 1){
                			vm.inventorystatus[i].statusName = true;
                		}else{
                			vm.inventorystatus[i].statusName = false;
                		}
                	}
                	vm.tableParams = new NgTableParams({
    					page : 1, // show first page
    					count : 20
    				// count per page
    				}, {
    					filterDelay : 0,
    					dataset : vm.inventorystatus
    				});
                }
            });
        }
    }
})();
